import React, { useEffect, useState, useRef } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { useFormik } from 'formik'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../../modules/auth'
import { useDispatch, useSelector } from 'react-redux'
import { Dispatch } from '@reduxjs/toolkit'
import { deleteCardById, deleteFileAttachment, updateCardById } from '../../services/cards'
import { awsFileUploadConfig } from '../../config/awsFileUpload'
import {
  useBoardPersons,
  useFileUploader,
  // useGetAllBoards,
  useGetColumns,
  useWebSocketHook,
} from '../../hooks'
import { setIsCardUpdated } from '../../store/slice/last-update-slice'
import { getTimeDateFormate } from '../../helper-functions/TimeFormate'
import UpdateCardForm from '../Forms/UpdateCardForm'
import ReactS3Client from 'react-aws-s3-typescript'
import useSendAlert from '../../hooks/useSendAlert'
import * as Yup from 'yup'
// import {setIsRender} from '../../store/slice/isRender-slice'
import { webSocketOperations } from '../../constants'
import { capitalizeEachWord } from '../../helper-functions/CapitalizeName'
import { longWordSlicing } from '../../helper-functions/CheckString'
// import {fetchAllCardByBoardId, fetchAllCardsofLoggedInUser} from '../../store/slice/card-slice'
// import EditCardSkeleton from '../../components/Modals/EditCardSkeleton'
import DropdownClone from '../../components/CloneCardDropdown'
import { removeNullFromReminder } from '../../helper-functions/RemoveNullFromReminders'
import '../../styles/updateanaddform.css'

import CloneCardModal from '../Modals/CloneCardModal'
import DeleteCardModal from '../Modals/DeleteCardModal'
import { useTheme } from '../../context/ThemeContext'
import useGetDescription from '../../hooks/useGetCardDescription'
import useGetTags from '../../hooks/useGetTags'
import { addBoardTags, removeBoardTags } from '../../store/slice/board-tags-slice'
import { applyColumnRules } from '../../utils/applyColumnRules'
import { autoCloneCard } from '../../utils/autoCloneCard'
import { upsertCurrentUserCard, upsertBoardCard, removeCardEverywhere } from '../../store/slice/card-slice'
import { cleanMentions } from '../../utils/cleanMentions'
import { assigneesChanged, dueDateChanged } from '../../utils/cardDirty'
import { extractRetainMentions } from '../../utils/extractRetainMentions'

// Strip the server-only fields and nulls off a card's reminders so they match
// the shape <Remainder> edits and the submit payload expects.
const normalizeReminders = (cardReminders: any) =>
  (cardReminders || []).map((reminder: any) => {
    //eslint-disable-next-line
    const { cardId, createdAt, updatedAt, ...rest } = reminder
    return Object.entries(rest).reduce((acc: any, [key, value]: [string, any]) => {
      if (value !== null) acc[key] = value
      return acc
    }, {})
  })

const cardSchema = Yup.object().shape({
  cardName: Yup.string()
    .min(3, 'Minimum 3 Characters')
    .max(300, 'Maximum 300 Characters')
    .required('Title is required')
    .trim(),

  columnName: Yup.string().required('Column is Required'),
  boardName: Yup.string().required('Board is Required'),
  status: Yup.string().required('Status is Required'),
})

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const EditNewCard = ({
  isBoard, toClone,
  cardDetails,
  cardModalShow,
  setCardModalShow,
  loading,
  handleCloneModalClose,
  cloneModalShow,
  cloneCardHandler,
  setToClone,
  handleCloneModalShow,
  isHomePage,
  setCards, allCards, cards,
  isLastUpdate,
  uniqueId,
  commentUniqueId,
  onNavigateNext,
  onNavigatePrev,
  hasNext,
  hasPrev,
  onNavigateBack,
  canGoBack,
  isExpandedProp,
  setIsExpandedProp
}: any): React.JSX.Element => {
  // const location = useLocation()
  const { cardDescription, setCardDescription, isCardDescriptionLoading, cardIdForDesc, initialDesc, fetchDescription, card } = useGetDescription(cardDetails?.id)

  const [desc, setDesc] = useState(null)
  const [editorTags, setEditorTags] = useState<any>(null)
  const [tocHeading, setTocHeading] = useState<any>(null);

  const [isExpandedLocal, setIsExpandedLocal] = useState(false)
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal
  const setIsExpanded = setIsExpandedProp !== undefined ? setIsExpandedProp : setIsExpandedLocal
  const [expandedField, setExpandedField] = useState<string | null>(null)
  const [showDetails, setShowDetails] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableDeleteCardBtn, setDisableDeleteCardBtn] = useState(false)
  const [showCardDelete, setShowCardDelete] = useState(false)
  const [deleteCardMsg, setDeleteCardMsg] = useState('')
  const handleClose = () => setShowCardDelete(false)
  const handleShow = () => setShowCardDelete(true)

  // const [editorDescriptionState, setEditorDescriptionState] = useState('')
  const [checkIsDescriptionExist] = useState(
    cardDescription ? true : false
  )
  const transformedTags = (cardDetails?.tags || []).map((tag: any) => ({
    value: tag.id,
    label: tag.name
  }));
  const [selectedTags, setSelectedTags] = useState(transformedTags)
  const [tagsToUpdate, setTagsToUpdate] = useState<any>({
    addedTags: [],
    removedTags: [],
  });

  const [boardId, setBoardId] = useState(cardDetails?.boardId)
  // Tag options follow the live board selection so switching to Board B loads
  // Board B's tags (columns already do this); cardDetails?.boardId would pin
  // them to the original Board A.
  const { tags, loading: tagsLoading } = useGetTags(boardId, 'card')
  const [columnId, setColumnId] = useState(cardDetails?.board_column_id)
  const [, setCardLength] = useState<number>()
  const [startDate, setStartDate] = useState<any>(
    cardDetails?.due_date && cardDetails?.due_time
      ? new Date(`${cardDetails?.due_date}T${cardDetails?.due_time}Z`)
      : ''
  )
  const [editorComment, setEditorComment] = useState('')
  const [commentFileInfo, setCommentFileInfo] = useState<any>([])
  const isLastUpdated: any = useSelector((state: any) => state.lastUpdateReducer)
  const [reminders, setReminders] = useState<any>([])
  const [deleteReminderIds, setDeletedReminderIds] = useState<any>([])
  const [retainMentions, setRetainMentions] = useState<any>([])
  const [mentions, setMentions] = useState<any>([])
  const { isCardUpdated } = isLastUpdated.isCardUpdated

  const dispatch: Dispatch<any> = useDispatch()
  const s3 = new ReactS3Client({
    ...awsFileUploadConfig,
    dirName: `cards-attachments/${process.env.REACT_APP_ENVIRONMENT}`,
  })
  const { allBoards, isBoardLoading } = useSelector((state: any) => state.allBoardsReducer)
  const childCommentRef: any = useRef()
  const params: any = useParams()
  const { currentUser }: any = useAuth()
  const navigate = useNavigate()
  const { id, fullName } = currentUser?.data.user

  // const boardFromReducer = useSelector((state: any) => state.boardReducer)
  // const { data: boards } = boardFromReducer?.entities

  // const {allBoards, isBoardLoading} = useGetAllBoards()


  const {
    columnResponse: columns,
    fetchColumnHandler,
    isColumnLoading,
  } = useGetColumns(boardId || params.boardId)

  const initialValues = {
    cardName: cardDetails?.card_name && cardDetails?.card_name.trim(),
    dueDate: cardDetails?.due_date,
    dueTime: cardDetails?.due_time,
    boardName: cardDetails?.board_name,
    columnName: cardDetails?.board_column_id,
    status: cardDetails?.status,
    priority: cardDetails?.priority,
  }
  const { pagesByBoardId: pages } = useSelector((state: any) => state.pageReducer)

  // let board = boards?.filter((item: any) => params.boardId === item.id)
  // let isPageArchiveBoard = window.location.href.includes('archived')
  const { sendJsonMessage }: any = useWebSocketHook()
  const { fileErrorMsg, selectedFile, setSelectedFile, selectFileHandler, setFileErrorMsg } =
    useFileUploader()

  const {
    optionsOfAssignee,
    isUserAssignLoading,
    selectAutoAssignee,
    setSelectAutoAssignee,
    optionsForSendAlert,
    boardPersonsForSendAlert,
    getBoardPersonHandler,
  } = useBoardPersons(cardDetails)
  // const isRenderStore = useSelector((state: any) => state.isRenderReducer)

  // const {isRender} = isRenderStore.isRender

  const {
    sendAlertToComment,
    setSendAlertToComment,
    sendAlertMsg,
    sendAlertMsgComment,
    sendAlertToBoardPerson,
    setSendAlertMsg,
    sendAlertToMentionPerson
  } = useSendAlert(
    boardPersonsForSendAlert,
    cardDetails,
    boardId,
    editorComment,
    desc
  )
  const [commentsLoading, setCommentsLoading] = useState<boolean>(true)

  useEffect(() => {
    if (commentUniqueId && !commentsLoading) {
      setTimeout(() => {
        const commentElement = document.querySelector(`div[data-id="comment-${commentUniqueId}"]`);
        if (commentElement) {
          commentElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 2000);
    }
  }, [commentUniqueId, commentsLoading]);


  const deleteFileHandler = async (name: string, key: string, value: string) => {
    let files: any
    if (key) {
      files = selectedFile.filter((item: any) => item.key !== key)
    } else {
      files = selectedFile.filter((item: any) => item.name !== name)
    }
    try {
      const fileNameForDelete = value || name
      await s3.deleteFile(fileNameForDelete)
      try {
        setSelectedFile(files)
        await deleteFileAttachment(cardDetails?.id, key, id, boardId)
      } catch (error) {
        return error
      }
    } catch (error) {
      return error
    }
  }

  const handleSubmission = async () => {
    const urls = []
    for (let index = 0; index < selectedFile.length; index++) {
      const filename = selectedFile[index].name
      if (filename) {
        const filenameUpdated = filename.substring(0, filename.lastIndexOf('.'))
        try {
          const uploadFile: any = await s3.uploadFile(selectedFile[index], filenameUpdated)
          urls.push(uploadFile.location)
        } catch (error) {
          return error
        }
      }
    }

    return urls
  }
  const deleteCardHandler = async () => {
    setDisableDeleteCardBtn(true)
    try {
      const res = await deleteCardById(cardDetails.id)
      setDeleteCardMsg(res.data.message)
      // Drop the deleted card from both redux card slices synchronously so
      // consumers that key off redux update without waiting for the laggy
      // full-list refetch below. In particular this lets the checklist
      // T-icon sync (TextEditor effect) unlink a checklist item — clearing
      // its task relation, reminder and assignees — the moment its linked
      // task is deleted, no page reload required.
      dispatch(removeCardEverywhere(cardDetails.id))
      // Deliberately NOT firing fetchAllCardsofLoggedInUser here. Its fulfilled
      // reducer REPLACES allCurrentUserCards wholesale, and read-after-write lag
      // means the server can still return the just-deleted card in that
      // response — clobbering the synchronous removeCardEverywhere above. On the
      // homepage the checklist T-icon sync resolves a linked task through that
      // slice (no board-scoped slice is loaded there), so the re-added card
      // makes the sync re-mirror the task's due date / assignees back onto the
      // checklist item and the link never resets. removeCardEverywhere already
      // drops the card from both slices — the only state change a delete
      // produces — so the refetch adds nothing but that race.
      setTimeout(() => {
        if (!isLastUpdate) {
          const filteredCards = isHomePage
            ? cards?.filter((card: any) => card.id !== cardDetails.id)
            : allCards?.filter((card: any) => card.id !== cardDetails.id);
          setCards(filteredCards);
        }
        // if(isLastUpdate) dispatch(setIsRender({isRender: !isRender}))
        if (isLastUpdate) {
          const filteredCards = cards?.filter((card: any) => card.id !== cardDetails.id)
          setCards(filteredCards);
        }
        dispatch(setIsCardUpdated({ isCardUpdated: !isCardUpdated }))
        setCardModalShow(false)
      }, 3000);
    }
    catch {
      // console.log(error)
    }
  }

  // const EditorImageViewerHandler = () => {
  //     var editImg: any = document.querySelectorAll(`div.ql-editor[contenteditable="true"] img`)
  //     for (let i = 0; i < editImg.length; i++) {
  //         editImg[i].style.maxWidth = '30%';
  //         editImg[i].classList.add('m-2');
  //         editImg[i].classList.add('cursor-pointer');
  //         editImg[i].addEventListener('click', () => {
  //             let imageSrc: any = editImg[i].getAttribute('src')
  //             setImageSrc(imageSrc)
  //             setShow(true)
  //         })
  //     }
  // }

  const gotoBoardHandler = () => {
    formik.handleSubmit()
    navigate(`/board/${cardDetails?.boardId}`)
  }
  const getAddedAndRemovedTags = () => {
    const addedTags = selectedTags?.filter((tag: any) => !transformedTags?.some((t: any) => t.value === tag.value));
    const removedTags = transformedTags?.filter((tag: any) => !selectedTags?.some((t: any) => t.value === tag.value));
    setTagsToUpdate({ addedTags, removedTags });
  };
  // const handleUpdateEditorComment = (boardName:string,key:string) => {
  //   setEditorComment((prev: any) => {
  //     const newComment = `This board was moved to board: <em>${boardName} as ${key}</em>`;
  //     return prev !== newComment ? newComment : prev; // Only update if the new value is different
  //   });

  // };


  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: cardSchema,
    onSubmit: async (values) => {

      setDisableBtn(true)
      const { utcDate, utcTime }: any = getTimeDateFormate(startDate)
      const fileLinks = await handleSubmission()

      const postDataBeforeRule = {
        created_by: fullName,
        last_modified_by: fullName,
        board_name: allBoards?.find((item: any) => item.board.id === boardId)?.board.name.trim(),
        card_name: values.cardName,
        description: cardDetails?.id === cardIdForDesc && (cardDescription && cardDescription?.length > 0 ? cleanMentions(cardDescription) : null) || null,
        due_date: startDate ? utcDate : null,
        due_time: startDate ? utcTime : null,
        position: cardDetails?.position,
        home_position: cardDetails?.home_position ?? cardDetails?.position,
        priority: values?.priority === 'Set priority' ? null : values?.priority || cardDetails?.priority,
        rag: null,
        status: values?.status,
        version: 1,
        applicationId: null,
        boardId: boardId,
        board_column_id: columnId,
        categoryId: null,
        componentId: null,
        customerId: null,
        productId: null,
        typeId: null,
        reporter: fullName,
        new_tagIds: tagsToUpdate?.addedTags?.length > 0
          ? tagsToUpdate.addedTags.map((tag: any) => tag.value)
          : [],
        remove_tagIds: tagsToUpdate?.removedTags?.length > 0
          ? tagsToUpdate.removedTags.map((tag: any) => tag.value)
          : [],
        assignees:
          optionsOfAssignee.length > 0
            ? selectAutoAssignee.map((item: any) => {
              return {
                board_person_id: item.value,
              }
            })
            : [],
        file_attachments: fileLinks,
        updateReminders: convertIdIntoCardReminderId(reminders as any),
        removeReminders: deleteReminderIds,
      }
      let postData: any
      const currentCol = columns?.find((col: any) => col.id === columnId)

      //Check to see if rules is needed to apply
      if (cardDetails.board_column_id === currentCol?.id) {
        postData = postDataBeforeRule
      } else {
        postData = applyColumnRules(postDataBeforeRule, currentCol);
      }

      let updatedCard: any
      let clonedCard: any;
      try {
        if (cardDetails?.boardId !== boardId) {

          // Change status to Archive of original card
          const archiveCardData: any = {
            ...postData,
            status: "archived",
            priority: cardDetails.priority,
            boardId: cardDetails.boardId,
            board_column_id: cardDetails.board_column_id,
            board_name: allBoards.find((item: any) => item.board.id === boardId)?.board.name.trim(),
            // Keep the archived original untouched: tag changes belong to the clone.
            new_tagIds: [],
            remove_tagIds: [],
          };
          const response = await updateCardById(archiveCardData, cardDetails?.id, id, boardId)
          updatedCard = response.data.data.card
          setEditorComment(`This card has been moved to the board: <em>${postData.board_name}</em>`)
          const res = await autoCloneCard(postData, id, cardDetails)
          clonedCard = res.data.data
          // handleUpdateEditorComment(postData.board_name,res.data.data.key)
        }
        else {
          // Simply updating a card
          const response = await updateCardById(postData, cardDetails?.id, id, boardId)
          updatedCard = response.data.data.card
        }
        // Push the update into redux FIRST so the board view can sync
        // even if the prop-based setCards below isn't wired (e.g. when
        // this modal was opened via the checklist T-icon through
        // LinkCardEdit, which doesn't pass setCards / allCards). Board.tsx
        // mirrors the board-scoped slice into its local cards list.
        if (updatedCard?.id) {
          dispatch(upsertCurrentUserCard(updatedCard))
          dispatch(upsertBoardCard(updatedCard))
        }
        // Robust assignee-name match: the server can return assignees as
        // either plain strings or `{fullName, board_person_id}` objects
        // depending on the endpoint version. The old `item === fullName`
        // compared objects to a string and always returned undefined, which
        // silently dropped the current user's card from their home list —
        // unmounting the open card modal on every save.
        const nameOf = (item: any) =>
          typeof item === 'string' ? item : item?.fullName ?? ''
        // Guard: when opened via the T-icon flow setCards/allCards/cards
        // aren't passed in, so the original direct setCards(...) call here
        // threw a TypeError and aborted the rest of the handler (which is
        // why the websocket / redux dispatches below never fired).
        if (typeof setCards === 'function') {
          if (!isLastUpdate) {
            // not last update card
            const filteredCards = isHomePage ? cards?.filter((card: any) => card.id !== cardDetails.id) : allCards?.filter((card: any) => card.id !== cardDetails.id)
            const checkAssignee = updatedCard.assignees.find((item: any) => nameOf(item) === fullName)
            const checkClonedAssignee = clonedCard && clonedCard?.assignees?.find((item: any) => nameOf(item) === fullName)
            if (isHomePage) {
              const newCards = [...filteredCards];
              if (checkClonedAssignee) {
                newCards.push(clonedCard);
              }
              if (checkAssignee) {
                newCards.push(updatedCard);
              }
              setCards(newCards);
            }
            else {
              setCards((prevCards: any) =>
                prevCards.map((card: any) => card.id === updatedCard.id ? { ...card, ...updatedCard } : card));
            }
          } else {
            // changes on Last update card
            const filteredCards = isHomePage ? cards?.filter((card: any) => card.id !== cardDetails.id) : allCards?.filter((card: any) => card.id !== cardDetails.id)
            const checkAssignee = updatedCard.assignees.find((item: any) => nameOf(item) === fullName)
            if (isHomePage) {
              const newCards = [...filteredCards];
              if (checkAssignee) {
                newCards.push(updatedCard);
              }
              setCards(newCards);
            }
            else {
              setCards((prevCards: any) =>
                prevCards.map((card: any) => card.id === updatedCard.id ? { ...card, ...updatedCard } : card));
            }
          }
        }
        // Only sync the viewed board's tag list on a same-board edit. On a
        // board change the tags belong to the destination board (the clone),
        // not the board currently in view, so don't inject them here.
        if (boardId === cardDetails?.boardId) {
          const addedTags = tagsToUpdate.addedTags.map((tag: any) => ({ label: tag.label, value: tag.value }));
          addedTags.length && dispatch(addBoardTags(addedTags));

          const removedTagIds = tagsToUpdate.removedTags.map((tag: any) => tag.value);
          removedTagIds.length && dispatch(removeBoardTags(removedTagIds));
        }
        const webSocketPayload: any = {
          event: 'publish',
          channel: boardId,
          userId: id,
          command: 'UPDATE',
          operation: webSocketOperations.cardUpdate,
          payload: {
            boardId: postData.boardId,
            cardId: cardDetails?.id,
            name: postData.card_name,
            priority: postData.priority,
            boardColumnId: postData.board_column_id,
            alert: `${capitalizeEachWord(fullName)} did changes in ${postData.board_name}- ${postData.number || cardDetails.key.split('-')[1]
              }.`,
          },
        }
        if (boardId !== cardDetails?.boardId) {
          sendJsonMessage(webSocketPayload)
          webSocketPayload.channel = cardDetails?.boardId
          sendJsonMessage(webSocketPayload)
        } else {
          sendJsonMessage(webSocketPayload)
        }
        sendAlertToMentionPerson(undefined, mentions, 'card-description')
        // sendAlertToBoardPerson(undefined, sendAlertTo, 'card-description')
        childCommentRef.current.addComment()
        childCommentRef.current.updateComment()
        // if(isLastUpdate) dispatch(setIsRender({isRender: !isRender}))

        dispatch(setIsCardUpdated({ isCardUpdated: !isCardUpdated }))
      } catch (error) {
        return error
      } finally {
        setDisableBtn(false)
        setSelectedFile([])

        // if (location.pathname !== '/home/board' && location.pathname !== '/home') {
        // dispatch(fetchAllCardsofLoggedInUser())
        // dispatch(fetchAllCardByBoardId({boardId: boardId, userId: id}))
        // }
        // Navigation saves keep the modal open (skip flag); every other save closes it.
        if (!skipModalCloseRef.current) {
          setCardModalShow(false)
        }
      }
    },
  })

  // When true, the onSubmit finally saves but leaves the modal open — used by
  // prev/next navigation, which saves the current card then swaps to another
  // instead of closing.
  const skipModalCloseRef = useRef(false)

  // ponytail: dirty check covers typed fields (title + description), newly
  // attached files (raw File objects have .name; already-uploaded attachments
  // carry showName instead) and every picker-driven field in the Details panel —
  // due date & time, tags, assignees, board, column, reminders — none of which
  // formik tracks, which is why they used to vanish when the modal was dismissed
  // by clicking away. Reminders only count add/remove, not an in-place edit of
  // an existing one; widen this if those get lost too.
  const hasUnsavedChanges = () =>
    formik.dirty ||
    (cardDescription ?? '') !== (initialDesc ?? '') ||
    selectedFile?.some((f: any) => f?.name) ||
    dueDateChanged(cardDetails, startDate) ||
    tagsToUpdate?.addedTags?.length > 0 ||
    tagsToUpdate?.removedTags?.length > 0 ||
    // Both pickers seed themselves from cardDetails and can briefly hold a falsy
    // value while their options load — only a real, different pick is a change.
    (!!boardId && boardId !== cardDetails?.boardId) ||
    (!!columnId && columnId !== cardDetails?.board_column_id) ||
    assigneesChanged(cardDetails, optionsOfAssignee, selectAutoAssignee) ||
    deleteReminderIds.length > 0 ||
    reminders.length !== (cardDetails?.card_reminders?.length ?? 0)

  // Save-on-close: persist edits whenever the card modal is dismissed — X icon,
  // Escape, or a backdrop click — so accidentally clicking away no longer drops
  // what the user typed. formik.onSubmit already closes the modal in its finally
  // block (and reads cardDescription), so a dirty card just runs handleSubmit;
  // if the title is invalid it keeps the modal open showing the error rather
  // than discarding the edit. A pristine card closes immediately with no
  // redundant save — which would otherwise spam "did changes" alerts to the
  // whole board every time someone merely opened and closed a card.
  const closeCard = () => {
    if (hasUnsavedChanges()) {
      formik.handleSubmit()
      return
    }
    setCardModalShow(false)
    setSelectedFile([])
    setTocHeading(null)
    setEditorTags(null)
  }

  // Save-on-navigate: the up/down arrows swap to the previous/next card. Save
  // the current card's edits first (awaited, so the in-flight submit reads this
  // card's state before cardDetails changes), then navigate. skipModalCloseRef
  // keeps the modal open across the save instead of closing it.
  const saveThenNavigate = async (navigateFn?: () => void) => {
    if (hasUnsavedChanges()) {
      skipModalCloseRef.current = true
      try {
        await formik.submitForm()
      } finally {
        skipModalCloseRef.current = false
      }
    }
    navigateFn?.()
  }

  function convertIdIntoCardReminderId(reminders: any) {
    const updatedReminders: any = reminders.map(({ id, ...reminder }: any) => {
      return { ...reminder, cardReminderId: id }
    })

    const removeNulls = removeNullFromReminder(updatedReminders)
    return removeNulls
  }


  useEffect(() => {
    const urlLinks: any = []
    if (cardDetails?.file_attachments) {
      for (const file of cardDetails?.file_attachments) {
        for (const [key, value] of Object.entries(file)) {
          const getFileName = (value as string)
            ?.toLowerCase()
            ?.split(`${process.env.REACT_APP_ENVIRONMENT}/`)[1]
          urlLinks.push({ key, value: value, showName: getFileName })
        }
      }
      setSelectedFile(urlLinks)
    }
    return () => setSelectedFile([])
    //eslint-disable-next-line
  }, [cardDetails?.id])

  // The prev/next arrows swap `cardDetails` without remounting this modal, so
  // every field formik doesn't own (it has enableReinitialize) has to resync by
  // hand. Otherwise the next card opens holding the previous card's due date,
  // tags, board and reminders — and save-on-close now counts those, which would
  // write them onto the card being viewed.
  useEffect(() => {
    setStartDate(
      cardDetails?.due_date && cardDetails?.due_time
        ? new Date(`${cardDetails.due_date}T${cardDetails.due_time}Z`)
        : ''
    )
    setBoardId(cardDetails?.boardId)
    setColumnId(cardDetails?.board_column_id)
    setSelectedTags(transformedTags)
    setReminders(normalizeReminders(cardDetails?.card_reminders))
    setDeletedReminderIds([])
    //eslint-disable-next-line
  }, [cardDetails?.id])

  useEffect(() => {

    if (boardId) {
      getBoardPersonHandler(boardId)
      fetchColumnHandler(boardId)
    }
    //eslint-disable-next-line
  }, [boardId, pages])

  useEffect(() => {
    extractRetainMentions(initialDesc || '', setRetainMentions)

  }, [cardDescription])
  useEffect(() => {
    getAddedAndRemovedTags()
  }, [selectedTags, cardDetails?.id])

  // Tags are board-specific: switching to another board clears the inherited
  // Board A selection so only the new board's tags can be assigned to the
  // clone; returning to the original board restores its tags.
  useEffect(() => {
    setSelectedTags(boardId === cardDetails?.boardId ? transformedTags : [])
    //eslint-disable-next-line
  }, [boardId])

  const handleCloneDropdown = () => {
    handleCloneModalShow()
    setToClone(cardDetails)
  }
  const { theme } = useTheme()

  return (
    <>
      {cloneModalShow && (
        <CloneCardModal
          isHomePage={isHomePage}
          loading={loading}
          closeModal={handleCloneModalClose}
          showModal={cloneModalShow}
          onCloneHandler={cloneCardHandler}
          card={cardDetails}
          toClone={toClone}
          cardDescription={cardDescription}
          openable
        />
      )}
      <Modal
        contentClassName={`${theme === 'dark' ? 'theme__div modal__bg' : ''} ${showDetails ? 'modal-content--details-open' : ''}`}
        dialogClassName={`modal-dialog-expandable ${isExpanded ? 'modal-dialog-expanded' : ''}`}
        show={cardModalShow}
        size='xl'
        aria-labelledby='contained-modal-title-vcenter'
        animation={false}
        onHide={() => {
          if (isExpanded) {
            setIsExpanded(false)
            return
          }
          closeCard()
        }}
        scrollable
        enforceFocus={false}
        restoreFocus={false}
      >
        {/* <Modal.Header closeButton>
                    <Modal.Title id='contained-modal-title-vcenter'>
                        {cardDetails?.board_name}- {cardDetails?.number}
                        </Modal.Title>
                        </Modal.Header> */}
        <div className='row d-flex align-items-center justify-content-between border-bottom fs-2 fw-bold py-8 px-6 modal-header-row'>
          {/* Back button, key/title and "Open in board" are grouped together so
              they sit flush at the far-left corner; the action cluster stays
              right-anchored via justify-content-between. */}
          <div className='d-flex align-items-center text-primary modal-header-title-group'>
            {canGoBack && (
              <button
                type='button'
                className='btn btn-sm btn-light p-3 me-3'
                onClick={onNavigateBack}
                title='Go back'
              >
                <i className='bi bi-arrow-left'></i>
              </button>
            )}

            <span className={`responsive-font ${theme === 'dark' ? 'b4-modal-title' : ''} `} style={{ marginRight: 20 }}>

              {longWordSlicing(cardDetails?.key?.trim())}
            </span>

            {isBoard === false && (
              <>
                <Button
                  className='btn-custom btn-custom-secondary goto-board-btn  btn btn-primary py-2 px-3'
                  onClick={gotoBoardHandler}
                >
                  Open in board
                </Button>

                <span onClick={gotoBoardHandler} className='link-span responsive-font'>
                  Open in board
                </span>
              </>
            )}
          </div>
          {/* Save lives inside the action cluster, left of Details, so Save +
              Details + nav move as one right-anchored group. The Save↔Details
              gap is a fixed internal gap that doesn't change when the prev/next
              icons are hidden (single item) or the archived delete button shows. */}
          <div className='col-3 modal-header-actions'>
            <Button
              disabled={(boardId?.length > 0 && columnId) || disableBtn ? false : true}
              className={`${disableBtn && 'btn-custom-secondary '} btn-sm px-5 modal-header-save-btn`}
              onClick={() => {
                formik.handleSubmit()
              }}
            >
              {disableBtn ? <Spinner animation='border' variant='light' /> : 'Save'}
            </Button>
            <button
              type='button'
              className={`btn btn-sm btn-outline-secondary modal-header-details-btn ${theme === 'dark' ? 'details-btn-dark' : 'text-dark'}`}
              onClick={() => setShowDetails(true)}
              title='Show details'
            >
              <i className={`bi bi-list-ul me-1 ${theme === 'dark' ? 'text-white' : 'text-dark'}`}></i>Details
            </button>
            <div className='d-flex align-items-center modal-header-clone-nav'>
              <div
                className='options-button text-end m-auto modal-header-clone'
                onClick={(e) => e.stopPropagation()}
              >
                <DropdownClone handleShowModal={handleCloneDropdown} cardData={cardDetails} category={'card'} />
              </div>
              {(hasPrev || hasNext) ? (
                <div className='d-flex align-items-center justify-content-center gap-1 h-100 modal-header-nav'>
                  <button
                    type='button'
                    className='btn btn-sm p-2'
                    onClick={() => saveThenNavigate(onNavigatePrev)}
                    disabled={!hasPrev}
                    title='Previous task'
                    style={{ opacity: hasPrev ? 1 : 0.4, background: 'none', border: 'none' }}
                  >
                    <i className='bi bi-chevron-up fs-2' style={{ color: theme === 'dark' ? '#ff7c00' : '#6c757d' }}></i>
                  </button>
                  <button
                    type='button'
                    className='btn btn-sm p-2'
                    onClick={() => saveThenNavigate(onNavigateNext)}
                    disabled={!hasNext}
                    title='Next task'
                    style={{ opacity: hasNext ? 1 : 0.4, background: 'none', border: 'none' }}
                  >
                    <i className='bi bi-chevron-down fs-2' style={{ color: theme === 'dark' ? '#ff7c00' : '#6c757d' }}></i>
                  </button>
                </div>
              ) : null}
            </div>

            {cardDetails?.status === 'archived' ?
              (<div className='cursor-pointer bg-danger text-center py-1 px-2 me-2 d-flex justify-content-center align-items-center' style={{ borderRadius: '8px' }}>
                <span onClick={handleShow}><i className={` bi bi-trash fs-3 p-1 mx-1 text-white`}></i></span>
              </div>)
              : null}
            
            <button
              type='button'
              className='expand-minimize-btn'
              onClick={() => setIsExpanded(!isExpanded)}
              title={isExpanded ? 'Minimize' : 'Expand to full screen'}
            >
              <i className={`bi ${isExpanded ? 'bi-fullscreen-exit' : 'bi-arrows-fullscreen'} fs-3`}
                style={{ color: theme === 'dark' ? '#ff7c00' : '#6c757d' }}
              ></i>
            </button>
            <div className=' text-end'>
              <span
                className='text-center p-2 cursor-pointer d-inline-block '
                onClick={closeCard}
              >
                X
              </span>
            </div>
          </div>
        </div>
        <Modal.Body className='px-6'>
          <div className='container-fluid px-0'>
            {/* {isColumnLoading || isBoardLoading ? (
              <EditCardSkeleton />
            ) : ( */}
            <UpdateCardForm
              formik={formik}
              setCardLength={setCardLength}
              boardId={boardId}
              allBoardsVar={allBoards}
              setBoardId={setBoardId}
              cardDetails={cardDetails}
              columns={columns}
              columnId={columnId}
              setColumnId={setColumnId}
              // handleChange={EditorImageViewerHandler}
              deleteFileHandler={deleteFileHandler}
              selectedFile={selectedFile}
              changeHandler={selectFileHandler}
              fileErrorMsg={fileErrorMsg}
              setFileErrorMsg={setFileErrorMsg}
              sendAlertMsg={sendAlertMsg}
              setSendAlertMsg={setSendAlertMsg}
              childCommentRef={childCommentRef}
              optionsForSendAlert={optionsForSendAlert}
              setSendAlertToComment={setSendAlertToComment}
              sendAlertToComment={sendAlertToComment}
              sendAlertToBoardPerson={sendAlertToBoardPerson}
              boardPersonsForSendAlert={boardPersonsForSendAlert}
              setEditorComment={setEditorComment}
              editorComment={editorComment}
              commentFileInfo={commentFileInfo}
              setCommentFileInfo={setCommentFileInfo}
              sendAlertMsgComment={sendAlertMsgComment}
              setStartDate={setStartDate}
              startDate={startDate}
              options={optionsOfAssignee}
              setSelected={setSelectAutoAssignee}
              selected={selectAutoAssignee}
              disableBtn={disableBtn}
              setEditor={setCardDescription}
              editor={cardDescription}
              setDesc={setDesc}
              checkIsDescriptionExist={checkIsDescriptionExist}
              setReminders={setReminders}
              reminders={reminders}
              setDeletedReminderIds={setDeletedReminderIds}
              isColumnLoading={isColumnLoading}
              isBoardLoading={isBoardLoading}
              isUserAssignLoading={isUserAssignLoading}
              isCardDescriptionLoading={isCardDescriptionLoading}
              setCards={setCards}
              tags={tags}
              loading={tagsLoading}
              selectedTags={selectedTags}
              setSelectedTags={setSelectedTags}
              transformedTags={transformedTags}
              setMentions={setMentions}
              retainMentions={retainMentions}
              uniqueId={uniqueId}
              sendAlertToMentionPerson={sendAlertToMentionPerson}
              commentsLoading={commentsLoading}
              setCommentsLoading={setCommentsLoading}
              editorTags={editorTags} setEditorTags={setEditorTags}
              tocHeading={tocHeading} setTocHeading={setTocHeading}
              getCardHandler={fetchDescription}
              cardLoading={isCardDescriptionLoading}
              isExpandedModal={isExpanded}
              envelopes={card?.envelopes || cardDetails?.envelopes}
              expandedField={expandedField}
              setExpandedField={setExpandedField}
              showDetails={showDetails}
              setShowDetails={setShowDetails}
            />
            {/* )} */}
          </div>
        </Modal.Body>
      </Modal>
      <DeleteCardModal deleteCardMsg={deleteCardMsg} setDeleteCardMsg={setDeleteCardMsg} disableBtn={disableDeleteCardBtn} showCardDelete={showCardDelete} handleClose={handleClose} deleteCardHandler={deleteCardHandler} cardName={longWordSlicing(cardDetails?.key?.trim())} />
      {/* {imageSrc && <ImageModal imageSrc={imageSrc} setShow={setShow} show={show} />
            }
            {video.length > 0 && (
                <VideoShowModal videoSrc={video} setShowVideo={setShowVideo} showVideo={showVideo} />
            )} */}
    </>
  )
}

export default EditNewCard
